import { Injectable, inject } from '@angular/core';
import { AccessControlService } from '@6grain/masofa-monolith-api-client/identity';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

/** Effective global permission codes from GET /identity/AccessControl/Me. */
@Injectable({ providedIn: 'root' })
export class OrchestrationAccessService {
  private readonly api = inject(AccessControlService);
  private codes$: Observable<string[]> | null = null;

  /** True when the signed-in user holds the global allow orchestration.admin. */
  hasOrchestrationAdmin(): Observable<boolean> {
    return this.codes().pipe(
      map(codes => codes.includes('orchestration.admin')),
    );
  }

  private codes(): Observable<string[]> {
    if (!this.codes$) {
      this.codes$ = this.api.identityAccessControlMeGet().pipe(
        map(codes => codes ?? []),
        catchError(() => of([] as string[])),
        shareReplay(1),
      );
    }
    return this.codes$;
  }
}
